import { render, staticRenderFns } from "./ParametrosList.vue?vue&type=template&id=4bc3932c&scoped=true"
import script from "./ParametrosList.vue?vue&type=script&lang=js"
export * from "./ParametrosList.vue?vue&type=script&lang=js"
import style0 from "./ParametrosList.vue?vue&type=style&index=0&id=4bc3932c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3932c",
  null
  
)

export default component.exports